import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { BreadcrumbService } from '../../util/telemetry/breadcrumb/breadcrumb.service';

/**
 * An invisible utility component that tracks React Router location changes
 * and adds them to the centralized BreadcrumbService.
 * Must be rendered inside a <BrowserRouter>.
 */
export const NavigationBreadcrumbs = () => {
  const location = useLocation();
  const lastPathname = useRef<string | null>(null);

  useEffect(() => {
    if (lastPathname.current === location.pathname) {
      return;
    }
    lastPathname.current = location.pathname;

    BreadcrumbService.add({
      category: 'navigation',
      message: `Navigated to ${location.pathname}`
    });
  }, [location.pathname]);

  return null;
};
